<template lang="html">
  <div class="mb4 pv3 ph4 pl-box-shadow">
    <div class="row col-xs center-xs middle-xs title">
      <span>Number of RoundTables</span>
      <i
        class="fa fa-info-circle"
        style="color: #848484"
        aria-hidden="true"
        v-my-tooltip="number_rts_description"
      />
    </div>
    <canvas id="number-of-rts-graph-data"></canvas>

    <pl-dialog
      v-if="show_modal"
      @close="show_modal = false"
      :maxWidth="'800px'"
      :maxHeight="'80%'"
      :padding="'2em'"
    >
      <div class="header-title mb2 center-xs">
        {{ header_modal }}
      </div>
      <div style="position: absolute; right: 10px; top: 0">
        <pl-button
          @click.native="show_modal = false"
          style="min-width: 0; font-size: 20px"
        >
          <strong>X</strong>
        </pl-button>
      </div>
      <div class="center-xs mb3 sub-header">
        <span> {{ sub_header_modal }} </span>
      </div>
      <div class="row mb3 b">
        <div class="col-xs-4">Title</div>
        <div class="col-xs-2">Students Invited</div>
        <div class="col-xs-3">Teacher</div>
        <div class="col-xs-3">Course / Section</div>
      </div>
      <div class="scroll">
        <div
          class="row middle-xs row-style"
          v-for="(rt, index) in roundtables_to_show"
          :key="index"
        >
          <div
            class="col-xs-4 truncate-text"
            :class="rt.course_school_id === school_id ? 'linkable' : ''"
            @click="goToRoundtable(header_modal, rt)"
          >
            {{ rt.title }}
          </div>
          <div class="col-xs-2 truncate-text p4">
            {{ rt.invited_users }}
          </div>
          <div class="col-xs-3 truncate-text">
            {{ rt.teacher_name }}
          </div>
          <div
            class="col-xs-3 truncate-text"
            :class="rt.course_school_id === school_id ? 'linkable' : ''"
            @click="goToCourse(rt)"
          >
            {{ rt.course_title }}
          </div>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import Chart from 'chart.js';
  import adminServices from 'services/admin/adminServices';
  import URLconfigs from 'services/apiConfigs';
  import courseDetailsService from 'services/courses';
  import { EventBus } from 'utils/event-bus';

  export default {
    watch: {
      analyticsNumberOfRts() {
        this.myLineChart.destroy();
        this.numberOfRtsChartData();
      },
    },
    props: {
      analyticsNumberOfRts: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        date: '',
        show_modal: false,
        myLineChart: [],
        roundtables_to_show: [],
        header_modal: '',
        sub_header_modal: '',
        school_id: null,
      };
    },
    computed: {
      number_rts_description() {
        return 'The bar charts contain the number of Written and Verbal RoundTables that were run in each of the months in the dates selected. Click into the bar charts to see an interactive list of these RoundTables.';
      },
    },
    methods: {
      numberOfRtsChartData() {
        const array = [];
        const payload = {
          type: 'bar',
          data: [],
        };
        if (this.analyticsNumberOfRts && this.analyticsNumberOfRts.length) {
          const month = this.analyticsNumberOfRts.map((label) => {
            const [year, month] = label.month.split('T')[0].split('-');

            return `${month}/${year}`;
          });

          payload.data.labels = month;

          const online_rts = this.analyticsNumberOfRts.map(
            (data) => data.roundtables.roundtables_count
          );
          const live_rts = this.analyticsNumberOfRts.map(
            (data) => data.roundtables.live_discussions_count
          );

          array.push(
            // {
            //   type: 'line',
            //   label: '% Live Roundtables',
            //   fill: false,
            //   borderColor: '#72ccd7',
            //   backgroundColor: '#72ccd7',
            //   tension: 0,
            //   data: live_rts,
            // },
            // {
            //   type: 'line',
            //   label: '% Online Roundtables',
            //   fill: false,
            //   borderColor: '#eb2d7C',
            //   backgroundColor: '#eb2d7C',
            //   tension: 0,
            //   data: online_rts,
            // },
            {
              label: 'Verbal RoundTables',
              borderColor: '#c6eff5',
              backgroundColor: '#c6eff5',
              data: live_rts,
            },
            {
              label: 'Written RoundTables',
              borderColor: 'pink',
              backgroundColor: 'pink',
              data: online_rts,
            }
          );

          (payload.data.datasets = array),
            (payload.options = {
              responsive: true,
              legend: {
                onHover: function (e) {
                  e.target.style.cursor = 'pointer';
                },
                labels: {
                  usePointStyle: true,
                  boxWidth: 7,
                },
              },
              scales: {
                xAxes: [
                  {
                    stacked: true,
                  },
                ],
                yAxes: [
                  {
                    stacked: true,
                  },
                ],
              },
              onClick: this.showModal.bind(this),
              tooltips: {
                xPadding: 25,
                yPadding: 15,
                titleAlign: 'center',
                footerAlign: 'center',
                bodyAlign: 'center',
                backgroundColor: '#fff',
                titleFontColor: '#595959',
                bodyFontColor: '#595959',
                footerFontColor: '#595959',
                borderWidth: 0.2,
                borderColor: '#595959',
                callbacks: {
                  label: function (tooltipItem, data) {
                    // if (tooltipItem.datasetIndex > 1) {
                    //   return data.datasets[tooltipItem.datasetIndex].data[
                    //     tooltipItem.index
                    //   ];
                    // }
                    // const previousValue =
                    //   data.datasets[tooltipItem.datasetIndex].data[
                    //     tooltipItem.index - 1
                    //   ];
                    // const value =
                    //   data.datasets[tooltipItem.datasetIndex].data[
                    //     tooltipItem.index
                    //   ];
                    // if (!previousValue) {
                    //   return value > 0 ? 100 + '%' : 0 + '%';
                    // } else {
                    //   const increaseValue = value - previousValue;
                    //   return (
                    //     ((increaseValue / previousValue) * 100).toFixed(1) + '%'
                    //   );
                    // }
                    return data.datasets[tooltipItem.datasetIndex].data[
                      tooltipItem.index
                    ];
                  },
                  footer: function (tooltipItem, data) {
                    // if (tooltipItem[0].datasetIndex > 1) {
                    //   return data.datasets[tooltipItem[0].datasetIndex].label;
                    // } else {
                    //   return [
                    //     data.datasets[
                    //       tooltipItem[0].datasetIndex
                    //     ].label.replace('%', ''),
                    //     'Participation Rate',
                    //   ];
                    // }
                    return data.datasets[tooltipItem[0].datasetIndex].label;
                  },
                },
                bodyFontSize: 30,
                displayColors: false,
              },
              hover: {
                onHover: function (e) {
                  var point = this.getElementAtEvent(e);
                  if (point.length) e.target.style.cursor = 'pointer';
                  else e.target.style.cursor = 'default';
                },
              },
            });
        }
        const ctx = document.getElementById('number-of-rts-graph-data');
        this.myLineChart = new Chart(ctx, payload);
      },

      showModal(e) {
        const chart = this.myLineChart.getElementAtEvent(e);
        if (chart && chart.length) {
          const month_year = chart[0]._view.label;
          const header_modal = chart[0]._view.datasetLabel;
          const date_time = new Date(
            month_year.split('/')[1] + '/' + month_year.split('/')[0] + '/1'
          );
          const begin_date =
            month_year.split('/')[1] + '/' + month_year.split('/')[0] + '/1';
          const year = date_time.getFullYear();
          const month = date_time.getMonth() + 1;
          const end_date =
            year +
            '/' +
            month +
            '/' +
            new Date(year, month, 0).getDate() +
            ' 23:59:59';
          const schoolID = this.$route.params.schoolID;
          const values = { begin_date, end_date };
          if (header_modal.includes('Written')) {
            adminServices
              .getSchoolAnalyticsOnlineRts(schoolID, values)
              .then((res) => {
                this.show_modal = true;
                this.header_modal = header_modal;
                this.sub_header_modal = month_year;
                this.roundtables_to_show = res.data;
              });
          } else {
            adminServices
              .getSchoolAnalyticsLiveRts(schoolID, values)
              .then((res) => {
                this.show_modal = true;
                this.header_modal = header_modal;
                this.sub_header_modal = month_year;
                this.roundtables_to_show = res.data;
              });
          }
        }
      },

      goToRoundtable(title, rt) {
        const { id, course_id, course_school_id } = rt;
        if (course_school_id === this.school_id) {
          courseDetailsService
            .createAdminSubscription(course_id, {
              school_id: this.$route.params.schoolID,
            })
            .then(() => {
              if (title.includes('Verbal')) {
                const url = `${URLconfigs.uiURL}/classes/${course_id}/roundtables/live/${id}`;
                window.open(url, '_blank');
              } else {
                const url = `${URLconfigs.uiURL}/classes/${course_id}/roundtables/online/${id}`;
                window.open(url, '_blank');
              }
            })
            .catch(() => {
              EventBus.$emit(
                'toast-msg',
                'Something went wrong...Please try again.'
              );
            });
        }
      },

      goToCourse(rt) {
        const { course_id, course_school_id } = rt;
        if (course_school_id === this.school_id) {
          courseDetailsService
            .createAdminSubscription(rt.course_id, {
              school_id: this.$route.params.schoolID,
            })
            .then(() => {
              const url = `${URLconfigs.uiURL}/classes/${course_id}/roundtables/`;
              window.open(url, '_blank');
            })
            .catch(() => {
              EventBus.$emit(
                'toast-msg',
                'Something went wrong...Please try again.'
              );
            });
        }
      },

      getPercentageChange(oldNumber, newNumber) {
        const increaseValue = newNumber - oldNumber;
        return (increaseValue / oldNumber) * 100;
      },
    },
    mounted() {
      this.school_id = this.$route.params.schoolID;
      this.numberOfRtsChartData();
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus'
  .header-title
    font-weight: 600
    color: #273248
    font-size: 24px
  .sub-header
    font-weight: 400
    color: #595959
    font-size: 16px
  .linkable
    text-decoration: underline;
    cursor: pointer;
  .title
    margin: 0 0 20px 0
    span
      margin-right: 10px
      font-size: 18px
      font-weight: 600
  .scroll
    padding-right:10px
    overflow-y: auto
    height:calc(80vh - 185px)
  .row-style
    color: pl-primary
    min-height: 30px
    border-bottom: 1px solid #e8e8e8
</style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// numberOfRtsGraph.vue?b46a2b30